
<template>
    <div ref="divHasContextMenu" class="has-context-menu" @click="showContextMenu" :key="id">
        <slot></slot>
    </div>
</template>

<script>

import store from '@/store/index.js';
import { EventBus } from '@/event-bus';

export default {
    props: {

        id : String,
        active: {
            default: true,
            type: Boolean
        },

        condition: {
            type: Function,
            //params => (divHasTooltip)
            default() {
                return true
            }
            
        },

        component : Object,

        options : {
            type: Array,
            default() {
                return []
            }         
        },

        addClass : {
            type: String,
            default : ''
        }
    },

    mounted(){
        EventBus.$on('receveidEventContextMenu-'+this.id, this.receveidEventContextMenu);
    },

    computed: {
        tooltipDisplay() {
            return this.$store.getters['tooltip/tooltipDisplay'];
        }
    },

    methods: {
        showContextMenu(event) {
            event.stopPropagation();
            console.log('$event',event)
            if(this.active && this.condition(this.$refs.divHasContextMenu)) {
                this.$store.commit('contextMenu/updateContextMenuEvent', event);
                this.$store.commit('contextMenu/updateContextMenuOptions', this.options);
                this.$store.commit('contextMenu/updateContextMenuDisplay', true);
                this.$store.commit('contextMenu/updateContextMenuId', this.id);         
                this.$store.commit('contextMenu/updateContextMenuClass', this.addClass); 
            }
        },

        hideContextMenu() {
            this.$store.commit('contextMenu/updateContextMenuDisplay', false);
        },

        receveidEventContextMenu(nameOption) {
            console.log("receveidEventContextMenu",nameOption)
            this.$emit('clickOption', this.id, nameOption)
        }
    },

    beforeDestroy() {
        console.log("beforeDestroy")
        this.hideContextMenu();
        EventBus.$off('receveidEventContextMenu-'+this.id, this.receveidEventContextMenu);
    },
}

</script>



